import { getColors, StyleSheet } from '@shopuptech/expo-shopup-ui';
import { theme } from './config';

const { BLACK, TITLE_TEXT_COLOR, WHITE } = getColors(theme);
const height = window.innerHeight;

export const commonStyles = StyleSheet.create({
  accessText: {
    color: TITLE_TEXT_COLOR,
  },
  overAll: {
    backgroundColor: WHITE,
    width: 426,
    borderRadius: 10,
    elevation: 5,
    shadowColor: BLACK,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.06,
    shadowRadius: 10,
    padding: 20,
    display: 'flex',
    gap: 12,
    maxHeight: height - 100,
  },
  contactText: {
    paddingHorizontal: 53,
    paddingTop: 26,
  },
  overAllConatiner: {
    height: height,
  },
  mail: {
    color: TITLE_TEXT_COLOR,
  },
});
